import _classCallCheck from "/builds/raisin-global/raisin-us/savebetter/savebetter/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/raisin-global/raisin-us/savebetter/savebetter/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/builds/raisin-global/raisin-us/savebetter/savebetter/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/builds/raisin-global/raisin-us/savebetter/savebetter/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/builds/raisin-global/raisin-us/savebetter/savebetter/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/raisin-global/raisin-us/savebetter/savebetter/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _slicedToArray from "/builds/raisin-global/raisin-us/savebetter/savebetter/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import _regeneratorRuntime from "/builds/raisin-global/raisin-us/savebetter/savebetter/node_modules/@babel/runtime/regenerator/index.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import * as e from "react";
import t, { createContext as r, Component as n, useState as o, useEffect as s, useContext as a } from "react";
import { initialize as l } from "launchdarkly-js-client-sdk";
export * from "launchdarkly-js-client-sdk";
import i from "lodash.camelcase";
import c from "hoist-non-react-statics";

var p = {
  useCamelCaseFlagKeys: !0,
  sendEventsOnFlagRead: !0
},
    u = r({
  flags: {},
  flagKeyMap: {},
  ldClient: void 0
}),
    f = u.Provider,
    y = u.Consumer,
    d = function d(e) {
  var t;
  return null != (t = e.context) ? t : e.user;
},
    g = function g(e) {
  var t = {};

  for (var _r in e) {
    0 !== _r.indexOf("$") && (t[i(_r)] = e[_r]);
  }

  return t;
},
    b = function b(e, t) {
  var r = {};

  for (var _n in e) {
    t && void 0 === t[_n] || (r[_n] = e[_n].current);
  }

  return r;
},
    h = function h(e, t) {
  var r = e.allFlags();
  return t ? Object.keys(t).reduce(function (e, n) {
    return e[n] = Object.prototype.hasOwnProperty.call(r, n) ? r[n] : t[n], e;
  }, {}) : r;
};

g.camelCaseKeys = g;

var O = Object.defineProperty,
    m = Object.getOwnPropertySymbols,
    v = Object.prototype.hasOwnProperty,
    j = Object.prototype.propertyIsEnumerable,
    P = function P(e, t, r) {
  return t in e ? O(e, t, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: r
  }) : e[t] = r;
},
    w = function w(e, t) {
  for (var r in t || (t = {})) {
    v.call(t, r) && P(e, r, t[r]);
  }

  if (m) {
    var _iterator = _createForOfIteratorHelper(m(t)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var r = _step.value;
        j.call(t, r) && P(e, r, t[r]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return e;
};

var C = {
  wrapperName: "react-client-sdk",
  wrapperVersion: "3.2.0",
  sendEventsOnlyForVariation: !0
},
    x = function x(e) {
  for (var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    t[_key - 1] = arguments[_key];
  }

  return r = void 0, n = [e].concat(t), o = /*#__PURE__*/_regeneratorRuntime.mark(function o(e) {
    var t,
        r,
        n,
        o,
        _args = arguments;
    return _regeneratorRuntime.wrap(function o$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            t = _args.length > 1 && _args[1] !== undefined ? _args[1] : {
              anonymous: !0,
              kind: "user"
            };
            r = _args.length > 2 ? _args[2] : undefined;
            n = _args.length > 3 ? _args[3] : undefined;
            o = l(e, t, w(w({}, C), r));
            return _context.abrupt("return", new Promise(function (e) {
              function t() {
                o.off("ready", s), o.off("failed", r);
              }

              function r(r) {
                t(), e({
                  flags: {},
                  ldClient: o,
                  error: r
                });
              }

              function s() {
                t();
                var r = h(o, n);
                e({
                  flags: r,
                  ldClient: o
                });
              }

              o.on("failed", r), o.on("ready", s);
            }));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, o);
  }), new Promise(function (e, t) {
    var s = function s(e) {
      try {
        l(o.next(e));
      } catch (e) {
        t(e);
      }
    },
        a = function a(e) {
      try {
        l(o.throw(e));
      } catch (e) {
        t(e);
      }
    },
        l = function l(t) {
      return t.done ? e(t.value) : Promise.resolve(t.value).then(s, a);
    };

    l((o = o.apply(r, n)).next());
  });
  var r, n, o;
};

function F(e, t) {
  var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : p;
  var n = arguments.length > 3 ? arguments[3] : undefined;

  var o = function (e, t) {
    if (void 0 === t) return e;
    return Object.keys(t).reduce(function (t, r) {
      return E(e, r) && (t[r] = e[r]), t;
    }, {});
  }(t, n),
      _r$useCamelCaseFlagKe = r.useCamelCaseFlagKeys,
      s = _r$useCamelCaseFlagKe === void 0 ? !0 : _r$useCamelCaseFlagKe,
      _ref = s ? function (e) {
    var t = {},
        r = {};

    for (var _n2 in e) {
      if (0 === _n2.indexOf("$")) continue;

      var _o = i(_n2);

      t[_o] = e[_n2], r[_o] = _n2;
    }

    return [t, r];
  }(o) : [o],
      _ref2 = _slicedToArray(_ref, 2),
      a = _ref2[0],
      _ref2$ = _ref2[1],
      l = _ref2$ === void 0 ? {} : _ref2$;

  return {
    flags: r.sendEventsOnFlagRead ? K(e, a, l, s) : a,
    flagKeyMap: l
  };
}

function E(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}

function K(e, t, r, n) {
  return new Proxy(t, {
    get: function get(t, o, s) {
      var a = Reflect.get(t, o, s),
          l = n && E(r, o) || E(t, o);
      if ("symbol" == typeof o || !l) return a;
      if (void 0 === a) return;
      var i = n ? r[o] : o;
      return e.variation(i, a);
    }
  });
}

var S = Object.defineProperty,
    k = Object.defineProperties,
    D = Object.getOwnPropertyDescriptors,
    I = Object.getOwnPropertySymbols,
    M = Object.prototype.hasOwnProperty,
    R = Object.prototype.propertyIsEnumerable,
    L = function L(e, t, r) {
  return t in e ? S(e, t, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: r
  }) : e[t] = r;
},
    z = function z(e, t) {
  for (var r in t || (t = {})) {
    M.call(t, r) && L(e, r, t[r]);
  }

  if (I) {
    var _iterator2 = _createForOfIteratorHelper(I(t)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var r = _step2.value;
        R.call(t, r) && L(e, r, t[r]);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return e;
},
    T = function T(e, t, r) {
  return L(e, "symbol" != typeof t ? t + "" : t, r), r;
},
    V = function V(e, t, r) {
  return new Promise(function (n, o) {
    var s = function s(e) {
      try {
        l(r.next(e));
      } catch (e) {
        o(e);
      }
    },
        a = function a(e) {
      try {
        l(r.throw(e));
      } catch (e) {
        o(e);
      }
    },
        l = function l(e) {
      return e.done ? n(e.value) : Promise.resolve(e.value).then(s, a);
    };

    l((r = r.apply(e, t)).next());
  });
};

var $ = /*#__PURE__*/function (_n3) {
  _inherits($, _n3);

  var _super = _createSuper($);

  function $(e) {
    var _this;

    _classCallCheck(this, $);

    _this = _super.call(this, e), T(_assertThisInitialized(_this), "state"), T(_assertThisInitialized(_this), "getReactOptions", function () {
      return z(z({}, p), _this.props.reactOptions);
    }), T(_assertThisInitialized(_this), "subscribeToChanges", function (e) {
      var t = _this.props.flags;
      e.on("change", function (r) {
        var n = _this.getReactOptions(),
            o = b(r, t),
            s = z(z({}, _this.state.unproxiedFlags), o);

        Object.keys(o).length > 0 && _this.setState(z({
          unproxiedFlags: s
        }, F(e, s, n, t)));
      });
    }), T(_assertThisInitialized(_this), "initLDClient", function () {
      return V(_assertThisInitialized(_this), null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this$props, e, t, r, n, o, s, a, _o2, l;

        return _regeneratorRuntime.wrap(function _callee$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$props = this.props, e = _this$props.clientSideID, t = _this$props.flags, r = _this$props.options;
                _context2.next = 3;
                return this.props.ldClient;

              case 3:
                n = _context2.sent;
                o = this.getReactOptions();
                a = this.state.unproxiedFlags;

                if (!n) {
                  _context2.next = 10;
                  break;
                }

                a = h(n, t);
                _context2.next = 14;
                break;

              case 10:
                _context2.next = 12;
                return x(e, d(this.props), r, t);

              case 12:
                _o2 = _context2.sent;
                s = _o2.error, s || (a = _o2.flags), n = _o2.ldClient;

              case 14:
                this.setState((l = z({
                  unproxiedFlags: a
                }, F(n, a, o, t)), k(l, D({
                  ldClient: n,
                  error: s
                })))), this.subscribeToChanges(n);

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee, this);
      }));
    });
    var t = e.options;

    if (_this.state = {
      flags: {},
      unproxiedFlags: {},
      flagKeyMap: {},
      ldClient: void 0
    }, t) {
      var _e = t.bootstrap;

      if (_e && "localStorage" !== _e) {
        var _this$getReactOptions = _this.getReactOptions(),
            _t = _this$getReactOptions.useCamelCaseFlagKeys;

        _this.state = {
          flags: _t ? g(_e) : _e,
          unproxiedFlags: _e,
          flagKeyMap: {},
          ldClient: void 0
        };
      }
    }

    return _this;
  }

  _createClass($, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      return V(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var e;
        return _regeneratorRuntime.wrap(function _callee2$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                e = this.props.deferInitialization;
                _context3.t0 = e && !d(this.props);

                if (_context3.t0) {
                  _context3.next = 5;
                  break;
                }

                _context3.next = 5;
                return this.initLDClient();

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(e) {
      return V(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var t, r;
        return _regeneratorRuntime.wrap(function _callee3$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                t = this.props.deferInitialization, r = !d(e) && d(this.props);
                _context4.t0 = t && r;

                if (!_context4.t0) {
                  _context4.next = 5;
                  break;
                }

                _context4.next = 5;
                return this.initLDClient();

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          e = _this$state.flags,
          r = _this$state.flagKeyMap,
          n = _this$state.ldClient,
          o = _this$state.error;
      return t.createElement(f, {
        value: {
          flags: e,
          flagKeyMap: r,
          ldClient: n,
          error: o
        }
      }, this.props.children);
    }
  }]);

  return $;
}(n);

var N = Object.defineProperty,
    U = Object.defineProperties,
    q = Object.getOwnPropertyDescriptors,
    A = Object.getOwnPropertySymbols,
    B = Object.prototype.hasOwnProperty,
    G = Object.prototype.propertyIsEnumerable,
    H = function H(e, t, r) {
  return t in e ? N(e, t, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: r
  }) : e[t] = r;
},
    J = function J(e, t) {
  for (var r in t || (t = {})) {
    B.call(t, r) && H(e, r, t[r]);
  }

  if (A) {
    var _iterator3 = _createForOfIteratorHelper(A(t)),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var r = _step3.value;
        G.call(t, r) && H(e, r, t[r]);
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }

  return e;
};

function Q(t) {
  return function (r) {
    var n = t.reactOptions,
        o = J(J({}, p), n),
        s = (a = J({}, t), U(a, q({
      reactOptions: o
    })));
    var a;

    function l(t) {
      return e.createElement($, J({}, s), e.createElement(r, J({}, t)));
    }

    return c(l, r), l;
  };
}

var W = Object.defineProperty,
    X = Object.getOwnPropertySymbols,
    Y = Object.prototype.hasOwnProperty,
    Z = Object.prototype.propertyIsEnumerable,
    _ = function _(e, t, r) {
  return t in e ? W(e, t, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: r
  }) : e[t] = r;
},
    ee = function ee(e, t) {
  for (var r in t || (t = {})) {
    Y.call(t, r) && _(e, r, t[r]);
  }

  if (X) {
    var _iterator4 = _createForOfIteratorHelper(X(t)),
        _step4;

    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var r = _step4.value;
        Z.call(t, r) && _(e, r, t[r]);
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  }

  return e;
};

function te(e) {
  return r = this, n = null, a = /*#__PURE__*/_regeneratorRuntime.mark(function a() {
    var r, n, a, l, i, _yield$x, c, u, y, g;

    return _regeneratorRuntime.wrap(function a$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            r = e.clientSideID;
            n = e.flags;
            a = e.options;
            l = e.reactOptions;
            i = ee(ee({}, p), l);
            _context5.next = 7;
            return x(r, d(e), a, n);

          case 7:
            _yield$x = _context5.sent;
            c = _yield$x.ldClient;
            u = _yield$x.flags;
            y = _yield$x.error;
            g = (null == a ? void 0 : a.bootstrap) && "localStorage" !== a.bootstrap ? a.bootstrap : u;
            return _context5.abrupt("return", function (_ref3) {
              var e = _ref3.children;

              var _o3 = o(function () {
                return ee({
                  unproxiedFlags: g
                }, F(c, g, i, n));
              }),
                  _o4 = _slicedToArray(_o3, 2),
                  r = _o4[0],
                  a = _o4[1];

              s(function () {
                function e(e) {
                  var t = b(e, n);
                  Object.keys(t).length > 0 && a(function (_ref4) {
                    var e = _ref4.unproxiedFlags;
                    var r = ee(ee({}, e), t);
                    return ee({
                      unproxiedFlags: r
                    }, F(c, r, i, n));
                  });
                }

                return c.on("change", e), function () {
                  c.off("change", e);
                };
              }, []);
              var l = r.flags,
                  p = r.flagKeyMap;
              return t.createElement(f, {
                value: {
                  flags: l,
                  flagKeyMap: p,
                  ldClient: c,
                  error: y
                }
              }, e);
            });

          case 13:
          case "end":
            return _context5.stop();
        }
      }
    }, a);
  }), new Promise(function (e, t) {
    var o = function o(e) {
      try {
        l(a.next(e));
      } catch (e) {
        t(e);
      }
    },
        s = function s(e) {
      try {
        l(a.throw(e));
      } catch (e) {
        t(e);
      }
    },
        l = function l(t) {
      return t.done ? e(t.value) : Promise.resolve(t.value).then(o, s);
    };

    l((a = a.apply(r, n)).next());
  });
  var r, n, a;
}

var re = Object.defineProperty,
    ne = Object.getOwnPropertySymbols,
    oe = Object.prototype.hasOwnProperty,
    se = Object.prototype.propertyIsEnumerable,
    ae = function ae(e, t, r) {
  return t in e ? re(e, t, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: r
  }) : e[t] = r;
},
    le = function le(e, t) {
  for (var r in t || (t = {})) {
    oe.call(t, r) && ae(e, r, t[r]);
  }

  if (ne) {
    var _iterator5 = _createForOfIteratorHelper(ne(t)),
        _step5;

    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var r = _step5.value;
        se.call(t, r) && ae(e, r, t[r]);
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }
  }

  return e;
};

function ie() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    clientOnly: !1
  };
  return function (r) {
    return function (n) {
      return e.createElement(y, null, function (_ref5) {
        var o = _ref5.flags,
            s = _ref5.ldClient;
        return t.clientOnly ? e.createElement(r, le({
          ldClient: s
        }, n)) : e.createElement(r, le({
          flags: o,
          ldClient: s
        }, n));
      });
    };
  };
}

var ce = function ce() {
  var _a = a(u),
      e = _a.flags;

  return e;
},
    pe = function pe() {
  var _a2 = a(u),
      e = _a2.ldClient;

  return e;
};

function ue() {
  var _a3 = a(u),
      e = _a3.error;

  return e;
}

export { $ as LDProvider, te as asyncWithLDProvider, g as camelCaseKeys, p as defaultReactOptions, ce as useFlags, pe as useLDClient, ue as useLDClientError, ie as withLDConsumer, Q as withLDProvider };